import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { GetInsurances, GetInvoices,GetCustomReports,GetCustomReportById,GetCustomReportByIdPaginated,GetInsurancesPaginated,GetInvoicesAggregated,GetRegisterTransactionReport,GetRefundReport,GetPaymentAdjustmentReport,GetAccountTransactionHistory,GetAccountsAgingReport,GetAccountCreditReport,GetBillingAdjustmentReport,GetPenaltyInterestReport,GetDelinquentAccountReport,GetTenantMasterList,GetLeaseAgreementTypeReport } from '../../REST/report'
import TextField from '@mui/material/TextField';
import { getAmount } from '../../helpers/amount';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import moment from 'moment'
import {
    DataGrid, GridToolbarContainer,
    GridToolbarExport, gridClasses,
    getGridDefaultColumnTypes,
    DEFAULT_GRID_COL_TYPE_KEY
} from '@mui/x-data-grid';
import ServerDataGrid from '../../Components/ServerDataGrid';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { gridDateFormat } from '../../helpers/dates';
import { useNavigate } from 'react-router-dom'

import Box from "@mui/material/Box"
import Dialog from '@mui/material/Dialog';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';

import {  styled } from '@mui/material/styles';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';

const StyledDataGrid =styled(DataGrid)(({ theme }) => ({
    
      "& .MuiDataGrid-renderingZone": {
        maxHeight: "none !important"
      },
      "& .MuiDataGrid-cell": {
        lineHeight: "unset !important",
        maxHeight: "none !important",
        whiteSpace: "normal"
      },
      "& .MuiDataGrid-row": {
        maxHeight: "none !important",
        cursor: "pointer !important"
      }
}));
const defaultColumnTypes = getGridDefaultColumnTypes();
function CustomToolbar() {
    return (
        <GridToolbarContainer className={gridClasses.toolbarContainer}>
            <GridToolbarExport  csvOptions={{fileName:"RevjectReport" }} printOptions={  { disableToolbarButton: true      }} />
        </GridToolbarContainer>
    );
}

export default function OtherReports() {
    const [type, setType] = React.useState('');
    const [customreports,setCustomreports] = React.useState([]);
    const navigate = useNavigate()
    useEffect(()=>{
        GetCustomReports().then(({data})=>{
            setCustomreports(data.map((t)=> { return {name: t.name ,id: t._id} }))
        })
    },[])
    const types = [
       {name: 'Monthly Billing Report', id:0},
       {name: 'Quarterly Billing Report', id:1},
       {name: 'Yearly Billing Report', id:2},
       {name: 'Monthly Collection Report',id:3},
       {name:  'Quarterly Collection Report',id:4},
       {name:  'Yearly Collection Report', id:5},
       {name: 'Expired Insurance Report', id:6},
       {name: 'Expiring Soon Insurance Report',id:7},
       {name: 'Payment Transactions', id:8},
       {name: 'Refund Report', id:9},
       {name: 'Payment Adjustment Report', id:10},
       {name: 'Billing Adjustment Report', id:11},
       {name: 'Account Transaction History', id:12},
       {name: 'Accounts Aging Report', id:13},
       {name: 'Account Credit Report', id:14},
       {name: 'Penalty & Interest Report', id:15},
       {name: 'Delinquent Account Report', id:16},
       {name: 'Tenant Master List', id:17},
       {name: 'Lease Agreement Type Report', id:18},
    ]

    const allreports = types.concat(customreports)
    const selectedReport = allreports.find(r => r.id === type)
    return (
        <PageShell>
            <PageHeader
                title={type === '' ? 'Interactive Reports' : selectedReport?.name}
                back
                onBack={() => type === '' ? navigate(-1) : setType('')}
            />
            <PageContent fill sx={{ overflowX: 'hidden' }}>
                {type === '' ? (
                    <List sx={{ width: '100%', flex: '1 1 auto', minHeight: 0, overflowY: 'auto' }}>
                        {allreports.map((r, idx) => (
                            <React.Fragment key={r.id}>
                                <ListItemButton onClick={() => setType(r.id)} sx={{ py: 1.5 }}>
                                    <ListItemText primary={r.name} />
                                    <ChevronRightIcon color="action" />
                                </ListItemButton>
                                {idx < allreports.length - 1 && <Divider component="li" />}
                            </React.Fragment>
                        ))}
                    </List>
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', height: '100%', minHeight: 0, minWidth: 0 }}>
                        {type === 0 && <MonthlyBilling />}
                        {type === 1 && <QuarterlyBilling />}
                        {type === 2 && <YearlyBilling />}
                        {type === 3 && <MonthlyCollection />}
                        {type === 5 && <YearlyCollection />}
                        {type === 4 && <QuarterlyCollection />}
                        {type === 6 && <ExpiredInsuranceReport type={'Expired'} />}
                        {type === 7 && <ExpiredInsuranceReport type={'Expiring Soon'} />}
                        {type === 8 && <PaymentTransactions />}
                        {type === 9 && <RefundReport />}
                        {type === 10 && <PaymentAdjustmentReport />}
                        {type === 11 && <BillingAdjustmentReport />}
                        {type === 12 && <AccountTransactionHistoryReport />}
                        {type === 13 && <AccountsAgingReport />}
                        {type === 14 && <AccountCreditReport />}
                        {type === 15 && <PenaltyInterestReport />}
                        {type === 16 && <DelinquentAccountReport />}
                        {type === 17 && <TenantMasterList />}
                        {type === 18 && <LeaseAgreementTypeReport />}
                        {![0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18].includes(type) && <CustomReport key={type} id={type} />}
                    </Box>
                )}
            </PageContent>
        </PageShell>
    )

}
const SelectReport = ({ label, onChange, options, selected }) => {
    return <FormControl className='py-2' fullWidth sx={{ mt: 1 }}>
        <InputLabel>{label}</InputLabel>
        <Select
            value={selected}
            placeholder="Choose a Report"
            label="Choose a Report"
            onChange={onChange}
        >
            {options.map(x => {
                return <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>
            })}
        </Select>
    </FormControl>        
}
const CustomSelect = ({ label, onChange, options, selected }) => {
    return <FormControl className='py-2' fullWidth sx={{ mt: 1 }}>
        <InputLabel>{label}</InputLabel>
        <Select
            value={selected}
            placeholder="Select Report Type"
            label="Report Type"
            onChange={onChange}
        >
            {options.map(x => {
                return <MenuItem key={x} value={x}>{x}</MenuItem>
            })}
        </Select>
    </FormControl>
}
const formatDate = (value)=>{
    let result = value
    try {
        result =  new Date(value).toLocaleString()
    } 
    catch (error) {
    }
    return result
}
const guessType = (value)=> {
     if (typeof value === 'number') {
      return 'number';
    }
    
    else if (typeof value === 'string') {
        let type = 'string'
        try {
            if ( new Date(value).toISOString() == value || new Date().toString() == value || new Date(value).toUTCString() == value) 
            type =  "date"
        } catch (error) {
            type = 'string'
        }
      return type;
    }
    else if (Array.isArray(value) ){
        return "array"
    } 
    else if (typeof value == "object" ){
        return "object"
    } 
   
    return 'string'; // Default to string if unsure
  }
  const customFilterOperator = ()=>{
    const operator = defaultColumnTypes[DEFAULT_GRID_COL_TYPE_KEY].filterOperators[0]
    const getApplyFilterFn = (filterItem, column) => {
        const innerFilterFn = operator.getApplyFilterFn(filterItem, column);
        if (!innerFilterFn || filterItem.value.length < 3) {
          return innerFilterFn;
        }
   
        return (params) => {
            const value = params.value
            const type = guessType(value)
            let bool = false
            if(type == "object")
            {
                Object.keys(value).forEach((t)=>{
                    if(value[t])
                    {
                        bool = bool || value[t].toUpperCase().includes(filterItem.value.toUpperCase())
                    }
                    
                })
            }
            else if(type == "array")
            {
                value.forEach((val)=>{
                    const itype = guessType(val)
                    if(itype == "object")
                    {
                        Object.keys(val).forEach((t)=>{
                            if(val[t])
                            {
                                bool = bool || val[t].toUpperCase().includes(filterItem.value.toUpperCase())
                            }
                           
                        })
                    }
                    else
                    {
                        bool = bool || val.toString().toUpperCase().includes(filterItem.value.toUpperCase())
                    }
                    
                })
            }
            return bool ;
        };
      }
    return {
        ...operator,
        getApplyFilterFn,
      }; 
  }
  const customObjectColumnFormatter = ({value})=>{
     
    Object.keys( value).map((z,i)=> {
        return z.charAt(0).toUpperCase() + z.slice(1)+": "+value[z]
    })
    .join(" | ")

        
  }
 const customObjectColumnRender = (params)=>(
    <Box  sx={{p:1}}>
        {
             Object.keys(params.value).map((z,i)=> (

                <span key={i}  >
                    <>
                        <b>{z.charAt(0).toUpperCase() + z.slice(1)}</b>
                        &nbsp;
                        <span>{ params.value[z]}</span>
                        &nbsp; 
                    </>
                    
                </span>
            ))
        }

    </Box>

 )
 const customArrayColumnFormatter  = (params) =>  {
    
    return params.value.map((t, index) => {
        if(guessType(t) != "object") 
        {
            return t;
        }
        else
        {
            return Object.keys(t).map((z,i)=>{
                return z.charAt(0).toUpperCase() + z.slice(1)+": "+ t[z]
            }).join(" | ")
        }
    }).join(" ; ")
 }  
 
  const customArrayColumnRender  = (params) =>   (
       <Box  sx={{p:1}}>
           
        {params.value.map((t, index) => 
            {
                
                if(guessType(t) != "object") 
                {
                    return (
                        <React.Fragment key={`value-${index}`}>
                            <span>{ t }</span>
                            <br/>
                        </React.Fragment>
                    )
                }
                else 
                {
                    return (
                        <React.Fragment key={`object-${index}`}>
                            { index != 0 && <hr style={{color: "#C2C2C2"}}  />}
                            {
                                
                                Object.keys(t).map((z,i)=> (

                                     
                                        <React.Fragment key={`${index}-${z}-${i}`}>
                                            <b>{z.charAt(0).toUpperCase() + z.slice(1)}</b>
                                            &nbsp;
                                            <span>{ t[z]}</span>
                                            <br/>
                                        </React.Fragment>
                                        
                                    
                                )
                            )
                            }
                        </React.Fragment> 
                    )
                }
            }
        )}
            
       </Box>
     )
    
 
const CustomReport = ({id})=>{
    const [sampleData, setSampleData] = useState(null)
    const [columns, setColumns] = useState([])

    useEffect(()=>{
        GetCustomReportById(id)
            .then(({data})=>{ 
                if(data && data.length > 0) {
                    setSampleData(data[0])
                    generateColumns(data[0])
                }
            })
    },[])

    const generateColumns = (sampleRow) => {
        if(!sampleRow) return;
        
        const cols = Object.keys(sampleRow).filter((p)=>{ return p != "_id"} ).map(key => {
            const datum = sampleRow[key]
            const type = guessType(datum);
            
            const column =  {
                field: key,
                flex:1,
                headerName: key.charAt(0).toUpperCase() + key.slice(1),
                type: type,
            }
            if(type == "array" )
            {
                column.type = "string"
                column.filterable= true
                column.filterOperators= [customFilterOperator()]
                column.sortable = false
                column.renderCell = customArrayColumnRender
                column.valueFormatter = customArrayColumnFormatter
            }
            else if (type == "object")
            {
                column.type = "string"
                column.filterable= true
                column.filterOperators= [customFilterOperator()]
                column.sortable = false
                column.renderCell = customObjectColumnRender
                column.valueFormatter = customObjectColumnFormatter
            } 
            else if(type == "date")
            {
                column.renderCell = (params)=>{
                    return (
                        <>
                            {formatDate(params.value)}
                        </>
                    )
                }
                column.valueFormatter = (params) =>{ return formatDate(params.value) }
            }   
            return column
         })
         setColumns(cols)
    }

    const fetchReportData = useCallback(async (page, limit, filters, sort) => {
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetCustomReportByIdPaginated(id, params)
        
        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }
        
        return { data: [], pagination: { total: 0, page: 1, pages: 1 } };
    }, [id]);

    if(sampleData == null) return (<h4>Loading...</h4>)
    if(columns.length == 0) return  (<h4>No Data found</h4>)
      
    return ( 
        <Box sx={{ height: '100%', width: 1, minWidth: 0, overflowX: 'hidden' }}>
            <ServerDataGrid
                columns={columns}
                fetchData={fetchReportData}
                initialPageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                getRowId={(row)=>{ return row._id }}
                fill
            />
        </Box> 
    )
}
const MonthlyBilling = () => {

    const [year, setYear] = useState(2026)
    const [month, setMonth] = useState('January')

    const years = [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026]
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const columns = [
        { field: 'id', headerName: 'id', flex: 0, hide: true },
        { field: 'company', headerName: 'Company Name', flex: 1 },
        { field: 'created', headerName: 'Created', flex: 1, valueFormatter: moneyFormat },
        { field: 'overDue', headerName: 'Overdue', flex: 1, valueFormatter: moneyFormat },
        { field: 'paid', headerName: 'Paid', flex: 1, valueFormatter: moneyFormat },
        { field: 'total', headerName: 'Total Billed', flex: 1, valueFormatter: moneyFormat }
    ]

    const fetchBillingData = useCallback(async (page, limit, filters, sort) => {
        const date = new Date(Date.parse('01 ' + month + ' ' + year))
        const begin = moment(date).clone().startOf('month').format('MM-DD-YYYY');
        const end = moment(date).clone().endOf('month').format('MM-DD-YYYY');
        
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetInvoicesAggregated({ begin, end }, params)
        
        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }
        
        return { data: [], pagination: { total: 0, page: 1, pages: 1 } };
    }, [year, month]);

    const handleYear = (event) => setYear(event.target.value);

    const handleMonth = (event) => setMonth(event.target.value);

    return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, gap: 2 }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Box sx={{ width: { xs: '100%', md: '33.3333%', lg: '25%' } }}><CustomSelect selected={year} label='Select Year' onChange={handleYear} options={years} /></Box>
            <Box sx={{ width: { xs: '100%', md: '33.3333%', lg: '25%' } }}><CustomSelect selected={month} label='Select Month' onChange={handleMonth} options={months} /></Box>
        </Box>
        <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
            <ServerDataGrid
                columns={columns}
                fetchData={fetchBillingData}
                initialPageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                getRowId={(row) => row.id}
                fill
            />
        </Box>
    </Box>
}

// Date-wise ledger of all payment/refund/adjustment transactions, with totals by payment method.
const PaymentTransactions = () => {
    const [begin, setBegin] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [end, setEnd] = useState(moment().endOf('day').format('YYYY-MM-DD'))
    const [rows, setRows] = useState([])
    const [byMethod, setByMethod] = useState([])
    const [totalAmount, setTotalAmount] = useState(0)
    const [loading, setLoading] = useState(false)
    
    // Details Dialog States
    const [selectedTx, setSelectedTx] = useState(null)
    const [detailsOpen, setDetailsOpen] = useState(false)

    const columns = [
        { field: 'createdAt', headerName: 'Date', flex: 0.6, valueFormatter: formatDate },
        { field: 'tenantName', headerName: 'Company', flex: 0.8 },
        { field: 'invoiceNumber', headerName: 'Invoice #', flex: 0.6 },
        { field: 'method', headerName: 'Method', flex: 0.5 },
        { field: 'gateway', headerName: 'Gateway', flex: 0.5 },
        { field: 'amount', headerName: 'Amount', flex: 0.5, valueFormatter: moneyFormat },
        { field: 'status', headerName: 'Status', flex: 0.5 },
        {
            field: 'actions',
            headerName: 'Action',
            flex: 0.3,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <IconButton 
                    color="primary" 
                    size="small" 
                    onClick={(e) => {
                        e.stopPropagation();
                        handleRowClick(params);
                    }}
                >
                    <VisibilityIcon fontSize="small" />
                </IconButton>
            )
        }
    ]

    const fetchTransactions = useCallback(async () => {
        setLoading(true)
        const result = await GetRegisterTransactionReport({
            begin: moment(begin).startOf('day').toISOString(),
            end: moment(end).endOf('day').toISOString()
        })
        const transactions = (result.data?.transactions || []).map(t => {
            // Group multi-invoice references cleanly in UI table column
            let invoiceNumbers = '';
            if (Array.isArray(t.invoiceIds) && t.invoiceIds.length > 0) {
                invoiceNumbers = t.invoiceIds.map(x => x.invoiceNumber).filter(Boolean).join(', ');
            } else {
                invoiceNumbers = t.invoiceId?.invoiceNumber || '';
            }

            return {
                ...t,
                id: t._id,
                tenantName: t.tenantId?.name || '',
                invoiceNumber: invoiceNumbers
            }
        }).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        setRows(transactions)
        setByMethod(result.data?.byMethod || [])
        setTotalAmount(result.data?.totalAmount || 0)
        setLoading(false)
    }, [begin, end])

    useEffect(() => { fetchTransactions() }, [fetchTransactions])

    const handleRowClick = (params) => {
        setSelectedTx(params.row)
        setDetailsOpen(true)
    }

    return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, gap: 2 }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
            <TextField
                type="date"
                label="From"
                value={begin}
                onChange={e => setBegin(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ width: { xs: '100%', md: '20%' } }}
            />
            <TextField
                type="date"
                label="To"
                value={end}
                onChange={e => setEnd(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ width: { xs: '100%', md: '20%' } }}
            />
            {byMethod.map(m => (
                <Box key={m.method} sx={{ px: 2, py: 1, borderRadius: 1, border: '1px solid #ddd' }}>
                    <div style={{ fontSize: 12, color: '#666' }}>{m.method} ({m.count})</div>
                    <div style={{ fontWeight: 600 }}>{getAmount(m.total)}</div>
                </Box>
            ))}
            <Box sx={{ px: 2, py: 1, borderRadius: 1, border: '1px solid #ddd', ml: 'auto' }}>
                <div style={{ fontSize: 12, color: '#666' }}>Total ({rows.length})</div>
                <div style={{ fontWeight: 600 }}>{getAmount(totalAmount)}</div>
            </Box>
        </Box>
        <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
            <StyledDataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                pageSize={25}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onRowClick={(params) => handleRowClick(params)}
                components={{ Toolbar: CustomToolbar }}
            />
        </Box>

        {/* Transaction Details Dialog */}
        <Dialog open={detailsOpen} onClose={() => setDetailsOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 600, borderBottom: '1px solid #ddd', pb: 1.5 }}>
                Transaction Detailed View
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
                {selectedTx && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Transaction Date</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                        {moment(selectedTx.createdAt).format('MM/DD/YYYY hh:mm A')}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Status</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600, color: selectedTx.status === 'Completed' ? 'success.main' : 'warning.main' }}>
                                        {selectedTx.status}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Tenant / Company</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedTx.tenantName || 'N/A'}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Invoice Number</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedTx.invoiceNumber || 'N/A'}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Payment Type</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedTx.type || 'N/A'}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Method</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedTx.method || 'N/A'}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Gateway</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedTx.gateway || 'N/A'}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Amount</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: selectedTx.direction === 'Credit' ? 'error.main' : 'success.main' }}>
                                        {selectedTx.direction === 'Credit' ? '-' : ''}{getAmount(selectedTx.amount)}
                                    </Typography>
                                </Box>
                            </Box>
                        </Paper>

                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Confirmation #</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600, fontFamily: 'monospace' }}>
                                        {selectedTx.gatewayConfirmation || 'N/A'}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">Performed By</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedTx.performedBy || 'N/A'}</Typography>
                                </Box>
                                <Box sx={{ gridColumn: 'span 2' }}>
                                    <Typography variant="caption" color="text.secondary">Payer Details</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                        {selectedTx.payerName ? `${selectedTx.payerName} (${selectedTx.payerEmail || 'No Email'})` : 'N/A'}
                                    </Typography>
                                </Box>
                            </Box>
                        </Paper>

                        {/* Line Items Paid Section */}
                        {((selectedTx.invoiceId?.lineItems && Array.isArray(selectedTx.invoiceId.lineItems)) || (selectedTx.invoiceIds && selectedTx.invoiceIds.some(inv => inv.lineItems && inv.lineItems.length > 0))) && selectedTx.lineItemUids && selectedTx.lineItemUids.length > 0 && (
                            <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }} color="primary">
                                    Line Items Paid in this Transaction
                                </Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    {(() => {
                                        const allInvoices = [
                                            selectedTx.invoiceId,
                                            ...(Array.isArray(selectedTx.invoiceIds) ? selectedTx.invoiceIds : [])
                                        ].filter(Boolean);

                                        // Flatten all populated line items across invoices
                                        const allLineItems = [];
                                        const seenUids = new Set();
                                        allInvoices.forEach(inv => {
                                            if (Array.isArray(inv.lineItems)) {
                                                inv.lineItems.forEach(item => {
                                                    if (!seenUids.has(item.uid)) {
                                                        seenUids.add(item.uid);
                                                        allLineItems.push({
                                                            ...item,
                                                            invoiceNumber: inv.invoiceNumber
                                                        });
                                                    }
                                                });
                                            }
                                        });

                                        return allLineItems
                                            .filter(item => selectedTx.lineItemUids.includes(item.uid))
                                            .map(item => (
                                                <Box key={item.uid} sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f0f0f0', pb: 0.5 }}>
                                                    <Box>
                                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.name}</Typography>
                                                        <Typography variant="caption" color="text.secondary">
                                                            {item.description} ({item.invoiceNumber || 'No Inv#'})
                                                        </Typography>
                                                    </Box>
                                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                                        {getAmount(item.charges * item.amount)}
                                                    </Typography>
                                                </Box>
                                            ));
                                    })()}
                                </Box>
                            </Paper>
                        )}

                        {/* Error Reason Banner */}
                        {selectedTx.status === 'Failed' && selectedTx.reason && (
                            <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, bgcolor: 'error.light', borderColor: 'error.main' }}>
                                <Typography variant="caption" color="error.dark" sx={{ fontWeight: 700, display: 'block', mb: 0.5 }}>
                                    FAILURE REASON
                                </Typography>
                                <Typography variant="body2" color="error.dark" sx={{ fontWeight: 600 }}>
                                    {selectedTx.reason}
                                </Typography>
                            </Paper>
                        )}
                    </Box>
                )}
            </DialogContent>
            <DialogActions sx={{ borderTop: '1px solid #ddd', px: 2, py: 1.5 }}>
                <Button onClick={() => setDetailsOpen(false)} variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    </Box>
}

// Shared date-range ledger report (Refund / Payment Adjustment / Billing Adjustment / Penalty & Interest).
const TransactionsByDateReport = ({ title, fetcher, columns, amountField = 'amount' }) => {
    const [begin, setBegin] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [end, setEnd] = useState(moment().endOf('day').format('YYYY-MM-DD'))
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchData = useCallback(async () => {
        setLoading(true)
        const result = await fetcher({
            begin: moment(begin).startOf('day').toISOString(),
            end: moment(end).endOf('day').toISOString()
        })
        const data = (result.data || []).map((r, idx) => ({ ...r, id: r._id || r.invoiceNumber || idx }))
        setRows(data)
        setLoading(false)
    }, [begin, end])

    useEffect(() => { fetchData() }, [fetchData])

    const total = rows.reduce((acc, r) => acc + (Number(r[amountField]) || 0), 0)

    return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, gap: 2 }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
            <TextField type="date" label="From" value={begin} onChange={e => setBegin(e.target.value)} InputLabelProps={{ shrink: true }} sx={{ width: { xs: '100%', md: '20%' } }} />
            <TextField type="date" label="To" value={end} onChange={e => setEnd(e.target.value)} InputLabelProps={{ shrink: true }} sx={{ width: { xs: '100%', md: '20%' } }} />
            <Box sx={{ px: 2, py: 1, borderRadius: 1, border: '1px solid #ddd', ml: 'auto' }}>
                <div style={{ fontSize: 12, color: '#666' }}>{title} Total ({rows.length})</div>
                <div style={{ fontWeight: 600 }}>{getAmount(total)}</div>
            </Box>
        </Box>
        <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
            <StyledDataGrid rows={rows} columns={columns} loading={loading} pageSize={25} rowsPerPageOptions={[10, 25, 50, 100]} components={{ Toolbar: CustomToolbar }} />
        </Box>
    </Box>
}

const RefundReport = () => <TransactionsByDateReport
    title="Refund"
    fetcher={GetRefundReport}
    columns={[
        { field: 'createdAt', headerName: 'Date', flex: 0.6, valueFormatter: formatDate },
        { field: 'tenantName', headerName: 'Company', flex: 0.8, valueGetter: p => p.row.tenantId?.name || '' },
        { field: 'invoiceNumber', headerName: 'Invoice #', flex: 0.6, valueGetter: p => p.row.invoiceId?.invoiceNumber || '' },
        { field: 'method', headerName: 'Method', flex: 0.5 },
        { field: 'reason', headerName: 'Reason', flex: 0.8 },
        { field: 'amount', headerName: 'Amount', flex: 0.5, valueFormatter: moneyFormat },
        { field: 'status', headerName: 'Status', flex: 0.5 },
    ]}
/>

const PaymentAdjustmentReport = () => <TransactionsByDateReport
    title="Payment Adjustment"
    fetcher={GetPaymentAdjustmentReport}
    columns={[
        { field: 'createdAt', headerName: 'Date', flex: 0.6, valueFormatter: formatDate },
        { field: 'tenantName', headerName: 'Company', flex: 0.8, valueGetter: p => p.row.tenantId?.name || '' },
        { field: 'invoiceNumber', headerName: 'Invoice #', flex: 0.6, valueGetter: p => p.row.invoiceId?.invoiceNumber || '' },
        { field: 'reason', headerName: 'Reason', flex: 0.8 },
        { field: 'performedBy', headerName: 'Performed By', flex: 0.5 },
        { field: 'amount', headerName: 'Amount', flex: 0.5, valueFormatter: moneyFormat },
        { field: 'status', headerName: 'Status', flex: 0.5 },
    ]}
/>

const BillingAdjustmentReport = () => <TransactionsByDateReport
    title="Billing Adjustment"
    fetcher={GetBillingAdjustmentReport}
    columns={[
        { field: 'invoiceDate', headerName: 'Date', flex: 0.6, valueFormatter: formatDate },
        { field: 'company', headerName: 'Company', flex: 0.8 },
        { field: 'invoiceNumber', headerName: 'Invoice #', flex: 0.6 },
        { field: 'description', headerName: 'Description', flex: 1 },
        { field: 'generationType', headerName: 'Type', flex: 0.5 },
        { field: 'amount', headerName: 'Amount', flex: 0.5, valueFormatter: moneyFormat },
        { field: 'status', headerName: 'Status', flex: 0.5 },
    ]}
/>

const PenaltyInterestReport = () => <TransactionsByDateReport
    title="Penalty & Interest"
    fetcher={GetPenaltyInterestReport}
    columns={[
        { field: 'itemDate', headerName: 'Date', flex: 0.6, valueFormatter: formatDate },
        { field: 'company', headerName: 'Company', flex: 0.8 },
        { field: 'invoiceNumber', headerName: 'Invoice #', flex: 0.6 },
        { field: 'itemName', headerName: 'Charge', flex: 0.7 },
        { field: 'amount', headerName: 'Amount', flex: 0.5, valueFormatter: moneyFormat },
        { field: 'paid', headerName: 'Paid', flex: 0.4, type: 'boolean' },
    ]}
/>

const AccountTransactionHistoryReport = () => {
    const [tenantId, setTenantId] = useState('')
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchHistory = useCallback(async () => {
        if (!tenantId) return
        setLoading(true)
        const result = await GetAccountTransactionHistory(tenantId)
        setRows((result.data || []).map(t => ({ ...t, id: t._id, invoiceNumber: t.invoiceId?.invoiceNumber || '' })))
        setLoading(false)
    }, [tenantId])

    const columns = [
        { field: 'createdAt', headerName: 'Date', flex: 0.6, valueFormatter: formatDate },
        { field: 'type', headerName: 'Type', flex: 0.5 },
        { field: 'invoiceNumber', headerName: 'Invoice #', flex: 0.6 },
        { field: 'method', headerName: 'Method', flex: 0.5 },
        { field: 'amount', headerName: 'Amount', flex: 0.5, valueFormatter: moneyFormat },
        { field: 'status', headerName: 'Status', flex: 0.5 },
    ]

    return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, gap: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <TextField label="Account / Tenant ID" value={tenantId} onChange={e => setTenantId(e.target.value)} sx={{ width: { xs: '100%', md: '30%' } }} />
            <Button variant="contained" onClick={fetchHistory}>Search</Button>
        </Box>
        <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
            <StyledDataGrid rows={rows} columns={columns} loading={loading} pageSize={25} rowsPerPageOptions={[10, 25, 50, 100]} components={{ Toolbar: CustomToolbar }} />
        </Box>
    </Box>
}

const AGING_BUCKETS = [
    { name: 'All', id: 'all' },
    { name: 'Current', id: 'current' },
    { name: '1-30 Days', id: 'days30' },
    { name: '31-60 Days', id: 'days60' },
    { name: '61-90+ Days', id: 'days90' },
]

const AccountsAgingReport = () => {
    const [bucket, setBucket] = useState('all')
    const [buckets, setBuckets] = useState({ current: [], days30: [], days60: [], days90: [] })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        GetAccountsAgingReport().then(({ data }) => {
            setBuckets(data || { current: [], days30: [], days60: [], days90: [] })
            setLoading(false)
        })
    }, [])

    const rows = (bucket === 'all'
        ? [...buckets.current, ...buckets.days30, ...buckets.days60, ...buckets.days90]
        : buckets[bucket] || []
    ).map((r, idx) => ({ ...r, id: r.invoiceNumber || idx }))

    const columns = [
        { field: 'invoiceNumber', headerName: 'Invoice #', flex: 0.6 },
        { field: 'tenant', headerName: 'Company', flex: 0.8 },
        { field: 'dueDate', headerName: 'Due Date', flex: 0.6, valueFormatter: formatDate },
        { field: 'daysOverdue', headerName: 'Days Overdue', flex: 0.5, type: 'number' },
        { field: 'balance', headerName: 'Balance', flex: 0.5, valueFormatter: moneyFormat },
    ]

    return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, gap: 2 }}>
        <Box sx={{ width: { xs: '100%', md: '33.3333%', lg: '25%' } }}>
            <CustomSelect label="Aging Bucket" selected={bucket} onChange={e => setBucket(e.target.value)} options={AGING_BUCKETS.map(b => b.id)} />
        </Box>
        <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
            <StyledDataGrid rows={rows} columns={columns} loading={loading} pageSize={25} rowsPerPageOptions={[10, 25, 50, 100]} components={{ Toolbar: CustomToolbar }} />
        </Box>
    </Box>
}

const DelinquentAccountReport = () => {
    const [bucket, setBucket] = useState('all')
    const [buckets, setBuckets] = useState({ days30: [], days60: [], days90: [] })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        GetDelinquentAccountReport().then(({ data }) => {
            setBuckets(data || { days30: [], days60: [], days90: [] })
            setLoading(false)
        })
    }, [])

    const delinquentBuckets = [
        { name: 'All Delinquent', id: 'all' },
        { name: '1-30 Days', id: 'days30' },
        { name: '31-60 Days', id: 'days60' },
        { name: '61-90+ Days', id: 'days90' },
    ]

    const rows = (bucket === 'all'
        ? [...buckets.days30, ...buckets.days60, ...buckets.days90]
        : buckets[bucket] || []
    ).map((r, idx) => ({ ...r, id: r.invoiceNumber || idx }))

    const columns = [
        { field: 'invoiceNumber', headerName: 'Invoice #', flex: 0.6 },
        { field: 'tenant', headerName: 'Company', flex: 0.8 },
        { field: 'dueDate', headerName: 'Due Date', flex: 0.6, valueFormatter: formatDate },
        { field: 'daysOverdue', headerName: 'Days Overdue', flex: 0.5, type: 'number' },
        { field: 'balance', headerName: 'Balance', flex: 0.5, valueFormatter: moneyFormat },
    ]

    return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, gap: 2 }}>
        <Box sx={{ width: { xs: '100%', md: '33.3333%', lg: '25%' } }}>
            <CustomSelect label="Delinquency Bucket" selected={bucket} onChange={e => setBucket(e.target.value)} options={delinquentBuckets.map(b => b.id)} />
        </Box>
        <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
            <StyledDataGrid rows={rows} columns={columns} loading={loading} pageSize={25} rowsPerPageOptions={[10, 25, 50, 100]} components={{ Toolbar: CustomToolbar }} />
        </Box>
    </Box>
}

const AccountCreditReport = () => {
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        GetAccountCreditReport().then(({ data }) => {
            setRows((data || []).map(r => ({ ...r, id: r.tenantId })))
            setLoading(false)
        })
    }, [])

    const columns = [
        { field: 'company', headerName: 'Company', flex: 1 },
        { field: 'unappliedCredit', headerName: 'Unapplied Credit', flex: 0.7, valueFormatter: moneyFormat },
    ]

    return <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
        <StyledDataGrid rows={rows} columns={columns} loading={loading} pageSize={25} rowsPerPageOptions={[10, 25, 50, 100]} components={{ Toolbar: CustomToolbar }} />
    </Box>
}

const TenantMasterList = () => {
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        GetTenantMasterList().then(({ data }) => {
            setRows((data || []).map((r, idx) => ({ ...r, id: idx })))
            setLoading(false)
        })
    }, [])

    const columns = [
        { field: 'tenantLastName', headerName: 'Last Name', flex: 0.6 },
        { field: 'tenantFirstName', headerName: 'First Name', flex: 0.6 },
        { field: 'company', headerName: 'Company', flex: 0.8 },
        { field: 'streetAddress', headerName: 'Street Address', flex: 0.9 },
        { field: 'city', headerName: 'City', flex: 0.5 },
        { field: 'state', headerName: 'State', flex: 0.3 },
        { field: 'zip', headerName: 'ZIP', flex: 0.4 },
        { field: 'email', headerName: 'Email', flex: 0.8 },
        { field: 'phone', headerName: 'Telephone', flex: 0.5 },
        { field: 'accountNumber', headerName: 'Account #', flex: 0.7 },
        { field: 'hangarNumber', headerName: 'Hangar #', flex: 0.5 },
        { field: 'leaseDate', headerName: 'Lease Date', flex: 0.6, valueFormatter: formatDate },
        { field: 'insuranceExpirationDate', headerName: 'Insurance Exp.', flex: 0.6, valueFormatter: formatDate },
        { field: 'aircraftNNumber', headerName: 'Aircraft N#', flex: 0.5 },
        { field: 'aircraftModel', headerName: 'Aircraft Model', flex: 0.6 },
        { field: 'aircraftType', headerName: 'Aircraft Type', flex: 0.5 },
        { field: 'depositAmount', headerName: 'Deposit', flex: 0.5, valueFormatter: moneyFormat },
        { field: 'monthlyRentAmount', headerName: 'Monthly Rent', flex: 0.5, valueFormatter: moneyFormat },
        { field: 'keyCode', headerName: 'Key Code', flex: 0.4 },
        { field: 'keysIssued', headerName: 'Keys Issued', flex: 0.4 },
    ]

    return <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
        <StyledDataGrid rows={rows} columns={columns} loading={loading} pageSize={25} rowsPerPageOptions={[10, 25, 50, 100]} components={{ Toolbar: CustomToolbar }} />
    </Box>
}

const LeaseAgreementTypeReport = () => {
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        GetLeaseAgreementTypeReport().then(({ data }) => {
            setRows((data || []).map(r => ({ ...r, id: r.agreementNumber })))
            setLoading(false)
        })
    }, [])

    const columns = [
        { field: 'leaseAgreementType', headerName: 'Lease Agreement Type', flex: 0.9 },
        { field: 'company', headerName: 'Tenant / Account', flex: 0.8 },
        { field: 'agreementNumber', headerName: 'Lease #', flex: 0.5 },
        { field: 'startDate', headerName: 'Start Date', flex: 0.5, valueFormatter: formatDate },
        { field: 'endDate', headerName: 'End Date', flex: 0.5, valueFormatter: formatDate },
        { field: 'status', headerName: 'Status', flex: 0.5 },
    ]

    return <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
        <StyledDataGrid rows={rows} columns={columns} loading={loading} pageSize={25} rowsPerPageOptions={[10, 25, 50, 100]} components={{ Toolbar: CustomToolbar }} />
    </Box>
}

const DetailView = ({ invoices, item }) => {

    const [rows, setRows] = useState([]);

    const columns = [
        { field: 'id', headerName: 'id', flex: 0, hide: true },
        { field: 'name', headerName: 'Invoice Name', flex: 1, },
        { field: 'description', headerName: 'Invoice Description', flex: 1 },
        { field: 'amountDue', headerName: 'Amount Due', flex: 1, type: 'number', valueFormatter: moneyFormat, filterable: false },
        { field: 'amountPaid', headerName: 'Amount Paid', flex: 1, type: 'number', valueFormatter: moneyFormat, filterable: false },
        { field: 'total', headerName: 'Total Billed', flex: 1, type: 'number', valueFormatter: moneyFormat, filterable: false }
    ]

    console.log('invoices', invoices)
    console.log('item', item)
    console.log('rows', rows)

    useEffect(() => {
        if (item.status === 'company' || item.status === 'total') {
            setRows(invoices.filter(x => x.companyId === item.id).map(x => { return { ...x, id: x.companyId, total: x.amountDue + x.amountPaid } }))
        }
        if (item.status === 'created') {
            setRows(invoices.filter(x => x.status === "Created" && x.companyId === item.id).map(x => { return { ...x, id: x.companyId, total: x.amountDue + x.amountPaid } }))
        }
        if (item.status === 'overDue') {
            setRows(invoices.filter(x => x.status === "Overdue" && x.companyId === item.id).map(x => { return { ...x, id: x.companyId, total: x.amountDue + x.amountPaid } }))
        }
        if (item.status === 'paid') {
            setRows(invoices.filter(x => x.status === "Paid" && x.companyId === item.id).map(x => { return { ...x, id: x.companyId, total: x.amountDue + x.amountPaid } }))
        }
    }, [item])

    return <TableView columns={columns} rows={rows} />

}

const TableView = ({ columns, rows, handleClick = null }) => {

    return <div style={{ height: '100%', width: '100%', minWidth: 0, overflowX: 'hidden' }}>
        <DataGrid
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 50]}
            onCellClick={handleClick}
            components={{
                Toolbar: CustomToolbar,
            }}
        />
    </div>
}

const moneyFormat = ({ value }) => {
    return '$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

const QuarterlyBilling = () => {

    const [value, setValue] = React.useState(1);

    const getQuarter = (v) => {
        const d = new Date();
        const currentMonth = d.getMonth() + 1; // 1-12
        const currentYear = d.getFullYear();
        
        let q = Math.ceil(currentMonth / 3);
        let y = currentYear;
        
        if (v == 2) {
            q = q - 1;
            if (q == 0) {
                q = 4;
                y = y - 1;
            }
        }
        return [y, q];
    }

    const getDates = (y, q) => {
        if (q == 1) {
            return ['01-01-' + y, '03-31-' + y]
        }
        if (q == 2) {
            return ['04-01-' + y, '06-30-' + y]
        }
        if (q == 3) {
            return ['07-01-' + y, '09-30-' + y]
        }
        if (q == 4) {
            return ['10-01-' + y, '12-31-' + y]
        }
        return ['01-01-' + y, '12-31-' + y]
    }

    const fetchQuarterlyData = useCallback(async (page, limit, filters, sort) => {
        const [year, month] = getQuarter(value)
        const [begin, end] = getDates(year, month)
        
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetInvoicesAggregated({ begin, end }, params)
        
        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }
        
        return { data: [], pagination: { total: 0, page: 1, pages: 1 } };
    }, [value]);

    const columns = [
        { field: 'id', headerName: 'id', flex: 0, hide: true },
        { field: 'company', headerName: 'Company Name', flex: 1 },
        { field: 'created', headerName: 'Created', flex: 1, valueFormatter: moneyFormat },
        { field: 'overDue', headerName: 'Overdue', flex: 1, valueFormatter: moneyFormat },
        { field: 'paid', headerName: 'Paid', flex: 1, valueFormatter: moneyFormat },
        { field: 'total', headerName: 'Total Billed', flex: 1, valueFormatter: moneyFormat }
    ]


    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, gap: 2 }}>
        <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            row
            value={value}
            onChange={handleChange}
        >
            <FormControlLabel value={1} control={<Radio />} label="Current Quarter" />
            <FormControlLabel value={2} control={<Radio />} label="Previous Quarter" />
        </RadioGroup>
        <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
            <ServerDataGrid
                columns={columns}
                fetchData={fetchQuarterlyData}
                initialPageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                getRowId={(row) => row.id}
                fill
            />
        </Box>
    </Box>
}

const YearlyBilling = () => {

    const [value, setValue] = React.useState(1);


    const getDates = (v) => {
        const d = new Date()
        const year = d.getFullYear()
        if (v == 1) {
            return ['01-01-' + year, '12-31-' + year]
        } else {
            return ['01-01-' + (year - 1), '12-31-' + (year - 1)]
        }
    }

    const fetchYearlyData = useCallback(async (page, limit, filters, sort) => {
        const [begin, end] = getDates(value)
        
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetInvoicesAggregated({ begin, end }, params)
        
        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }
        
        return { data: [], pagination: { total: 0, page: 1, pages: 1 } };
    }, [value]);

    const columns = [
        { field: 'id', headerName: 'id', flex: 0, hide: true },
        { field: 'company', headerName: 'Company Name', flex: 1 },
        { field: 'created', headerName: 'Created', flex: 1, valueFormatter: moneyFormat },
        { field: 'overDue', headerName: 'Overdue', flex: 1, valueFormatter: moneyFormat },
        { field: 'paid', headerName: 'Paid', flex: 1, valueFormatter: moneyFormat },
        { field: 'total', headerName: 'Total Billed', flex: 1, valueFormatter: moneyFormat }
    ]


    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, gap: 2 }}>
        <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            row
            value={value}
            onChange={handleChange}
        >
            <FormControlLabel value={1} control={<Radio />} label="Current Year" />
            <FormControlLabel value={2} control={<Radio />} label="Previous Year" />
        </RadioGroup>
        <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
            <ServerDataGrid
                columns={columns}
                fetchData={fetchYearlyData}
                initialPageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                getRowId={(row) => row.id}
                fill
            />
        </Box>
    </Box>
}

const MonthlyCollection = () => {

    const [year, setYear] = useState(2026)
    const [month, setMonth] = useState('January')

    const fetchCollectionData = useCallback(async (page, limit, filters, sort) => {
        const date = new Date(Date.parse('01 ' + month + ' ' + year))
        const begin = moment(date).clone().startOf('month').format('MM-DD-YYYY');
        const end = moment(date).clone().endOf('month').format('MM-DD-YYYY');
        
        const params = { page, limit }
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetInvoicesAggregated({ begin, end }, params)
        
        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }
        
        return { data: [], pagination: { total: 0, page: 1, pages: 1 } }
    }, [year, month]);

    const years = [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026]
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const columns = [
        { field: 'id', headerName: 'id', flex: 0, hide: true },
        { field: 'company', headerName: 'Company Name', flex: 1 },
        { field: 'paid', headerName: 'Paid', flex: 1, valueFormatter: moneyFormat },
    ]

    const handleYear = (event) => setYear(event.target.value);

    const handleMonth = (event) => setMonth(event.target.value);

    return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, gap: 2 }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Box sx={{ width: { xs: '100%', md: '33.3333%', lg: '25%' } }}><CustomSelect selected={year} label='Select Year' onChange={handleYear} options={years} /></Box>
            <Box sx={{ width: { xs: '100%', md: '33.3333%', lg: '25%' } }}><CustomSelect selected={month} label='Select Month' onChange={handleMonth} options={months} /></Box>
        </Box>
        <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
            <ServerDataGrid
                columns={columns}
                fetchData={fetchCollectionData}
                fill
            />
        </Box>
    </Box>
}

const QuarterlyCollection = () => {

    const [value, setValue] = React.useState(1);

    // Oct-Dec = 1
    // Jan-Mar = 2
    // Apr-Jun = 3
    // Jul-Sep = 4
    const getQuarter = (v) => {
        const d = new Date();
        let m = Math.floor(d.getMonth() / 3) + 2;
        m -= m > 4 ? 4 : 0;
        let y = d.getFullYear() + (m == 1 ? 1 : 0);
        if (v == 1)
            return [y, m];
        if (v == 2) {
            m = m - 1
            if (m == 0) m = 4
            if (m == 1) y = y - 1
            return [y, m]
        }

    }

    const getDates = (y, m) => {
        if (m == 1) {
            return ['10-01-' + y, '12-31-' + y]
        }
        if (m == 2) {
            return ['01-01-' + y, '03-31-' + y]
        }
        if (m == 3) {
            return ['04-01-' + y, '06-30-' + y]
        }
        if (m == 4) {
            return ['07-01-' + y, '09-30-' + y]
        }
    }

    const fetchQuarterlyData = useCallback(async (page, limit, filters, sort) => {
        const [year, month] = getQuarter(value)
        const [begin, end] = getDates(year, month)
        
        const params = { page, limit }
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetInvoicesAggregated({ begin, end }, params)
        
        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }
        
        return { data: [], pagination: { total: 0, page: 1, pages: 1 } }
    }, [value])

    const columns = [
        { field: 'id', headerName: 'id', flex: 0, hide: true },
        { field: 'company', headerName: 'Company Name', flex: 1 },
        { field: 'paid', headerName: 'Paid', flex: 1, valueFormatter: moneyFormat },
    ]


    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, gap: 2 }}>
        <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            row
            value={value}
            onChange={handleChange}
        >
            <FormControlLabel value={1} control={<Radio />} label="Current Quarter" />
            <FormControlLabel value={2} control={<Radio />} label="Previous Quarter" />
        </RadioGroup>
        <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
            <ServerDataGrid
                columns={columns}
                fetchData={fetchQuarterlyData}
                fill
            />
        </Box>
    </Box>
}

const YearlyCollection = () => {

    const [value, setValue] = React.useState(1);


    const getDates = (v) => {
        const d = new Date()
        const year = d.getFullYear()
        if (v == 1) {
            return ['01-01-' + year, '12-31-' + year]
        } else {
            return ['01-01-' + (year - 1), '12-31-' + (year - 1)]
        }
    }

    const fetchYearlyData = useCallback(async (page, limit, filters, sort) => {
        const [begin, end] = getDates(value)
        
        const params = { page, limit }
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetInvoicesAggregated({ begin, end }, params)
        
        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }
        
        return { data: [], pagination: { total: 0, page: 1, pages: 1 } }
    }, [value])

    const columns = [
        { field: 'id', headerName: 'id', flex: 0, hide: true },
        { field: 'company', headerName: 'Company Name', flex: 1 },
        { field: 'paid', headerName: 'Paid', flex: 1, valueFormatter: moneyFormat },
    ]


    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, gap: 2 }}>
        <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            row
            value={value}
            onChange={handleChange}
        >
            <FormControlLabel value={1} control={<Radio />} label="Current Year" />
            <FormControlLabel value={2} control={<Radio />} label="Previous Year" />
        </RadioGroup>
        <Box sx={{ flex: '1 1 auto', minHeight: 0, minWidth: 0 }}>
            <ServerDataGrid
                columns={columns}
                fetchData={fetchYearlyData}
                fill
            />
        </Box>
    </Box>
}

const ExpiredInsuranceReport = (type) => {

    const navigate = useNavigate()

    const columns = [
        { field: 'id', headerName: 'id', flex: 0, hide: true },
        { field: 'companyName', headerName: 'Company Name', flex: 1 },
        { field: 'type', headerName: 'Insurance Type', flex: 1 },
        { field: 'startDate', headerName: 'Start Date', flex: 1, type: 'date', valueFormatter: gridDateFormat },
        { field: 'endDate', headerName: 'End Date', flex: 1, type: 'date', valueFormatter: gridDateFormat },
        { field: 'createdAt', headerName: 'Created Date', flex: 1, type: 'date', valueFormatter: gridDateFormat },
    ]

    const fetchInsurances = useCallback(async (page, limit, filters, sort) => {
        const params = {
            page,
            limit
        }
        
        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }
        
        if (sort) {
            params.sort = JSON.stringify(sort)
        }
        
        const result = await GetInsurancesPaginated(type.type, params)
        
        if (result.data?.data) {
            return {
                data: result.data.data,
                pagination: result.data.pagination
            };
        }
        
        return { data: [], pagination: { total: 0, page: 1, pages: 1 } };
    }, [type.type]);

    const handleClick = (e) => {
        navigate('/companies/' + e.company)
    }

    return <Box sx={{ height: '100%', width: '100%', minWidth: 0 }}>
            <ServerDataGrid
                columns={columns}
                fetchData={fetchInsurances}
                initialPageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                getRowId={(row) => row.id}
                onRowClick={(params) => handleClick(params.row)}
                fill
            />
    </Box>
}
